import React, { useEffect, useState, useRef } from 'react';
import { Button } from './Button';
import { Download, FileText, TableProperties, FileSpreadsheet, ChevronDown } from 'lucide-react';
import { exportToCSV, exportToExcel, exportToPDF, ExportColumn } from '../utils/exportUtils';
interface ExportDropdownProps {
  data: any[];
  filename: string;
  columns: ExportColumn[];
  title: string;
}
export function ExportDropdown({
  data,
  filename,
  columns,
  title
}: ExportDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative" ref={dropdownRef} data-id="element-171">
      <Button variant="outline" size="sm" onClick={() => setIsOpen(!isOpen)} className="font-mono text-xs uppercase tracking-widest border-border/50 bg-background/50" data-id="element-172">
        <Download className="w-3 h-3 mr-2" data-id="element-173" /> Ekspor{' '}
        <ChevronDown className="w-3 h-3 ml-2" data-id="element-174" />
      </Button>

      {isOpen && <div className="absolute right-0 mt-1 w-40 bg-card border border-border/50 rounded shadow-lg overflow-hidden z-50 animate-in fade-in slide-in-from-top-2" data-id="element-175">
          <button onClick={() => {
        exportToPDF(data, filename, columns, title);
        setIsOpen(false);
      }} className="w-full flex items-center px-3 py-2 text-xs font-mono text-foreground hover:bg-primary/10 hover:text-primary transition-colors" data-id="element-176">
            <FileText className="w-4 h-4 mr-2" data-id="element-177" /> PDF
          </button>
          <button onClick={() => {
        exportToExcel(data, filename, columns);
        setIsOpen(false);
      }} className="w-full flex items-center px-3 py-2 text-xs font-mono text-foreground hover:bg-primary/10 hover:text-primary transition-colors border-t border-border/30" data-id="element-178">
            <FileSpreadsheet className="w-4 h-4 mr-2" data-id="element-179" /> Excel
          </button>
          <button onClick={() => {
        exportToCSV(data, filename, columns);
        setIsOpen(false);
      }} className="w-full flex items-center px-3 py-2 text-xs font-mono text-foreground hover:bg-primary/10 hover:text-primary transition-colors border-t border-border/30" data-id="element-180">
            <TableProperties className="w-4 h-4 mr-2" data-id="element-181" /> CSV
          </button>
        </div>}
    </div>;
}